import { render, staticRenderFns } from "./CartList.vue?vue&type=template&id=53284c56&scoped=true"
import script from "./CartList.vue?vue&type=script&lang=js"
export * from "./CartList.vue?vue&type=script&lang=js"
import style0 from "./CartList.vue?vue&type=style&index=0&id=53284c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53284c56",
  null
  
)

export default component.exports